import { InventoryListGettingFormModel } from '@/models/CampaignOperation/Form'
import httpClient from './httpClient'

export default class {
  static async fetchInventoryTargetingList(params) {
    try {
      const res = await httpClient.get(`/targeting/inventory_list`, {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e, 'error of fetchInventoryTargetingList')
      throw e
    }
  }

  static async fetchInventoryRequiredLists(
    insertionorderId,
    ownerProfileMenuId,
  ) {
    try {
      const res = await httpClient.get(
        `/insertion_order/inventory_list/required?insertion_order_id=${insertionorderId}&owner_profile_menu_id=${ownerProfileMenuId}`,
      )
      return InventoryListGettingFormModel.assign(res.data)
    } catch (e) {
      console.log(e, 'error of fetchInventoryRequiredLists')
      throw e
    }
  }

  static async fetchInventoryOptionalLists(
    insertionorderId,
    ownerProfileMenuId,
  ) {
    try {
      const res = await httpClient.get(
        `/insertion_order/inventory_list/optional?insertion_order_id=${insertionorderId}&owner_profile_menu_id=${ownerProfileMenuId}`,
      )
      return InventoryListGettingFormModel.assign(res.data)
    } catch (e) {
      console.log(e, 'error of fetchInventoryOptionalLists')
      throw e
    }
  }
}
